export default "__VITE_ASSET__jGaLg$OU__"